import React from "react";
import { useAppellations } from "@/hooks/useAppellations";
import AppellationInsight from "@/components/AppellationInsight";

/**
 * Drop-in block for article-like pages. Given a `text` prop containing the
 * full body (title + description + paragraphs concatenated), it detects
 * known appellations and renders a "Explorer sur la carte" section with a
 * collapsible AppellationInsight card per detected appellation.
 *
 * Renders nothing when zero appellations are detected — safe to sprinkle
 * anywhere without visual clutter.
 */
export default function AppellationsInText({ text, title = "Explorer sur la carte interactive", compact = false }) {
  const appellations = useAppellations(text);
  if (!appellations.length) return null;
  return (
    <div className={compact ? "mt-4 space-y-2" : "mt-8 space-y-3"} data-testid="appellations-in-text">
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#E5276A] font-bold">{title}</div>
      {appellations.map((a) => (
        <AppellationInsight key={a.slug || a.name} appellation={a} />
      ))}
    </div>
  );
}
